// extracted by mini-css-extract-plugin
module.exports = {"contact":"Contact_contact__hRSB-","button":"Contact_button__1F7H1"};